import { ExternalLink, SecondaryButton } from "@graffer-inc/console-design-kit";
import { useState } from "react";
import "./feedback.scss";
import Analytics from "../../../common/analytics";
import { BaseTypeLiterals } from "../../../application/domain/base/base-type";
import { isLGWANURL } from "@graffer-inc/smart-apply";

type FeedbackStateType = "DEFAULT" | "YES" | "NO";

type Matcher<R> = BaseTypeLiterals<FeedbackStateType, R>;

const matchState = (
  value: FeedbackStateType,
  matcher: Matcher<JSX.Element>,
) => {
  if (value === "YES") {
    return matcher["YES"];
  }
  if (value === "NO") {
    return matcher["NO"];
  }
  return matcher["DEFAULT"];
};

const useOnClick = (
  feedbackType: "YES" | "NO",
  callback: React.Dispatch<React.SetStateAction<FeedbackStateType>>,
  contentPageURL: string,
) => {
  return () => {
    callback(feedbackType);
    Analytics.clickHelpFeedBack({
      url: contentPageURL,
      feedbackType,
    });
  };
};

export const Feedback: React.FC<{
  contentPageURL: string;
}> = ({ contentPageURL }) => {
  const [feedbackState, setFeedbackState] =
    useState<FeedbackStateType>("DEFAULT");

  const onClickYes = useOnClick("YES", setFeedbackState, contentPageURL);

  const onClickNo = useOnClick("NO", setFeedbackState, contentPageURL);

  return (
    <>
      {matchState(feedbackState, {
        DEFAULT: (
          <div className="help-feedback-box">
            <div className="help-feedback-box-title-wrapper">
              <p className="help-feedback-box-title">
                このページの内容は役に立ちましたか？
              </p>
              <div className="help-feedback-button-group">
                <SecondaryButton onClick={onClickYes} text={"はい"} />
                <SecondaryButton onClick={onClickNo} text={"いいえ"} />
              </div>
            </div>
          </div>
        ),
        YES: (
          <div className="help-feedback-box">
            <p className="help-feedback-box-title">
              ご意見ありがとうございます！
            </p>
            <div className="help-feedback-box-content">
              <p className="help-feedback-box-content-text">
                いただいたご意見は、ヘルプサイト改善の参考にいたします。
              </p>
            </div>
          </div>
        ),
        NO: (
          <div className="help-feedback-box">
            <p className="help-feedback-box-title">
              お役に立てず申し訳ございません。ぜひ改善点を教えてください。
            </p>
            <div className="help-feedback-box-content">
              <p className="help-feedback-box-content-text">
                お手数ですが、下記アンケートからご入力お願いいたします。
              </p>
              <div className="help-feedback-box-secondary-content">
                <ExternalLink
                  anchor={(props) => (
                    <a
                      {...props}
                      href={
                        isLGWANURL(contentPageURL)
                          ? "https://ttzk.graffer.bsninet.asp.lgwan.jp/graffer-support/smart-apply/surveys-alias/help-feedback"
                          : "https://ttzk.graffer.jp/graffer-support/smart-apply/surveys-alias/help-feedback "
                      }
                      target={"_blank"}
                      rel={"noopener noreferrer"}
                    >
                      {props.children}
                    </a>
                  )}
                >
                  アンケートはこちら
                </ExternalLink>
              </div>
            </div>
          </div>
        ),
      })}
    </>
  );
};
